import React, { useState, useEffect } from 'react'

import { string, bool } from 'prop-types'

import Breadcrumb from './Components/Breadcrumb'
import ProfileHeader from './Components/ProfileHeader'
import Sales from './Components/Sales'
import { getSalesTabs } from './Static/constants'

function MySalesNew({
  userPaymentMethod = null,
  newRoyaltyUi = false,
  userReferral = false,
  giftModelType = null,
  maximizeEarningsForceOptIn = false,
  isSubscriptionParticipant: initialParticipant = false,
}) {
  const visibleTabs = getSalesTabs(newRoyaltyUi, userReferral)
  const visibleTabIds = visibleTabs.map((tab) => tab.id)
  const defaultTab = visibleTabs[0]?.id

  const [activeTab, setActiveTab] = useState(defaultTab)
  const [isSubscriptionParticipant, setIsSubscriptionParticipant] = useState(initialParticipant)

  useEffect(() => {
    const hash = window.location.hash.replace('#', '')
    if (hash && visibleTabIds.includes(hash)) {
      setActiveTab(hash)
    }

    const handleParticipationChanged = (participating) => setIsSubscriptionParticipant(participating)
    App.events.subscribe('subscription:participation:changed', handleParticipationChanged)

    return () => {
      const unsub = App.events.unsubscribe || App.events.remove
      unsub.call(App.events, 'subscription:participation:changed', handleParticipationChanged)
    }
  }, [])

  useEffect(() => {
    const hash = window.location.hash.replace('#', '')
    if (hash !== activeTab) {
      window.history.replaceState(null, '', `#${activeTab}`)
    }
  }, [activeTab])

  const handleTabChange = (tabId) => {
    setActiveTab(tabId)
    window.history.pushState(null, '', `#${tabId}`)
  }

  return (
    <div className="my-sales-new__container">
      <ProfileHeader
        userPaymentMethod={userPaymentMethod}
        giftModelType={giftModelType}
      />
      <Sales
        activeTab={activeTab}
        onTabChange={handleTabChange}
        showOverviewTab={newRoyaltyUi}
        showReferralTab={userReferral}
        maximizeEarningsForceOptIn={maximizeEarningsForceOptIn}
        isSubscriptionParticipant={isSubscriptionParticipant}
      />
      {!newRoyaltyUi && <Breadcrumb />}
    </div>
  )
}

MySalesNew.propTypes = {
  userPaymentMethod: string,
  newRoyaltyUi: bool,
  userReferral: bool,
  giftModelType: string,
  maximizeEarningsForceOptIn: bool,
  isSubscriptionParticipant: bool,
}

export default MySalesNew
